// extracted by mini-css-extract-plugin
export default {"container":"auth-page_container__ZbyBa","formContainer":"auth-page_formContainer__nldg+"};